import React from 'react';
import LegalPage from './LegalPage';
import { PRIVACY_SECTIONS, LAST_UPDATED } from './legalContent';

const Privacy: React.FC = () => (
  <LegalPage
    title="Privacy Policy"
    lastUpdated={LAST_UPDATED}
    intro={
      'TopoSDS holds the paperwork a delivery contractor is required to keep — licenses, medical '
      + 'certificates, background checks, accident records. This explains what we collect, what we do '
      + 'with it, who else touches it, how long it is kept, and how to delete your account.'
    }
    sections={PRIVACY_SECTIONS}
  />
);

export default Privacy;
